import { createFileRoute } from "@tanstack/react-router";

import { AdminShell } from "@/components/admin/AdminShell";
import { KycReviewPage } from "@/components/admin/KycReviewPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/kyc")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="kyc">
      <KycReviewPage />
    </AdminShell>
  ),
});
